import { cn } from "@/lib/utils";

// Official X (formerly Twitter) glyph — lucide has no X-brand mark, so we inline it.
export function XLogo({ className }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

// Opens X's compose window prefilled with copy + link. The user reviews before posting (no auto-tweet),
// so this is safe with zero backend and works today.
export function openTweet({ text, url }) {
  const intent = `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  window.open(intent, "_blank", "noopener,noreferrer");
}

export function ShareToXButton({ text, url, onShare, className, iconOnly = false, testid }) {
  const handleClick = () => {
    onShare?.();
    openTweet({ text, url });
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testid}
      title="Share on X"
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full transition-colors",
        iconOnly ? "p-1.5 text-bloq-muted hover:text-white" : "",
        className,
      )}
    >
      <XLogo className={iconOnly ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {!iconOnly && <span>Share on X</span>}
    </button>
  );
}
